import { render, staticRenderFns } from "./TopPopularFormats.vue?vue&type=template&id=2844bf52&scoped=true"
import script from "./TopPopularFormats.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopPopularFormats.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TopPopularFormats.vue?vue&type=style&index=0&id=2844bf52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2844bf52",
  null
  
)

export default component.exports